import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import StudentDetailHeader from './studentHeader';
import StudentLeads from './studentLeads';
import StudentNoteList from './studentNoteList';

const StudentDetail = () => {
  const { id, ongoing } = useParams();
  const decodedId = useMemo(() => {
    return decodeURIComponent(id);
  }, [id]);

  const decodedOngoing = useMemo(() => {
    const result = decodeURIComponent(ongoing);
    if (result === 'true') {
      return true;
    }
    return false;
  }, [ongoing]);

  return (
    <div className="student-detail">
      <StudentDetailHeader studentId={decodedId} />
      <StudentLeads studentId={decodedId} ongoing={decodedOngoing} />
      <StudentNoteList studentId={decodedId} />
    </div>
  );
};

export default StudentDetail;
